import React from 'react';
import FontAwesome from 'react-fontawesome';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../translations/lang/en-US.json';
import MDSpinner from 'react-md-spinner';
import { connect } from 'react-redux';

// Material Loading icon goes here.
export const MdLoader = ({ color, size = 50 }) => {
  return <MDSpinner singleColor={color} size={size} />;
};

export const MdLoaderTheme = connect(state => ({
  color: '#' + state.dashboard.merchantDetails.lavu_togo_theme,
}))(MdLoader);

export const MdLoaderWhite = connect(state => ({
  color: '#FFFFFF',
}))(MdLoader);

export function Loading(props, context) {
  const sectionLoading = {
    color: 'rgb(115, 153, 0)',
    position: 'fixed',
    zIndex: '50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: 0,
  };

  const paraVal = {
    padding: '0',
    marginTop: '32px',
    color: 'rgba(0,0,0,0.87)',
    fontSize: '16px',
    fontWeight: 'bold',
  };

  const spinner = {
    width: 'auto',
    height: '100px',
    textAlign: 'center',
  };

  const _message = props.message || (
    <FormattedMessage
      id="loadingPleaseWait"
      defaultMessage={defaultMsg.loadingPleaseWait}
    />
  );

  return (
    <div style={sectionLoading}>
      <div style={spinner}>
        <MdLoaderTheme />
        <p style={paraVal}>{_message}</p>
      </div>
    </div>
  );
}

export function LoadingList() {
  return (
    <div className="text-center">
      <FontAwesome name="spinner" spin className="olo-client-theme-color" />
    </div>
  );
}

export const LocationLoader = () => {
  return (
    <div className="row">
      <div
        className="text-center col-md-12 olo-client-theme-color font-small"
        style={{ fontSize: '12px' }}
      >
        <MdLoaderTheme size={25} />
      </div>
    </div>
  );
};

export const LoadingText = () => {
  return (
    <div className="row">
      <div
        className="text-center col-md-12 olo-client-theme-color font-samll"
        style={{ fontSize: '12px' }}
      >
        <FormattedMessage
          id="loadingPleaseWait"
          defaultMessage={defaultMsg.loadingPleaseWait}
        />
      </div>
    </div>
  );
};
export default Loading;



// WEBPACK FOOTER //
// ./src/views/common/Loading.jsx